import { render, staticRenderFns } from "./BadRoute.vue?vue&type=template&id=fbb635d8"
import script from "./BadRoute.vue?vue&type=script&lang=js"
export * from "./BadRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports